'use strict';

/* global $ */

function GallerySlider(options){
    var opt = $.extend({
        selector: '.js-gallery-slider',
        itemSelector: '.js-gallery-slider-item',
        navSelector: '.js-gallery-slider-nav',
        slider: {}
    }, options);

    $(opt.selector).each(function() {
        let $items = $(opt.itemSelector),
            $nav = $(opt.navSelector);

        $items.slider($.extend({}, opt.slider, {
            nav: $nav
        }));
    });
}

export {
    GallerySlider
};

